import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Doughnut } from "react-chartjs-2"; // Import Doughnut for Pie chart
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { useTheme } from "../ThemeContext"; // Import your theme context
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faFileInvoice, faCheckCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import {dashboardApi} from "../api/api";
import {Loader} from '@mantine/core'
ChartJS.register(ArcElement, Tooltip, Legend, Title);

// Sample data for Doughnut chart
const data = {
  labels: ["Design", "Construction", "Documentation", "Review"],
  datasets: [
    {
      label: "Task Distribution",
      data: [40, 30, 20, 10], // Static data representing task distribution
      backgroundColor: [
        "rgba(255, 99, 132, 0.6)",
        "rgba(54, 162, 235, 0.6)",
        "rgba(255, 206, 86, 0.6)",
        "rgba(75, 192, 192, 0.6)",
      ],
      borderColor: [
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
      ],
      borderWidth: 1,
    },
  ],
};

const iconMapping = {
  "Total Projects": faClipboardList,
  "Active Contracts": faFileInvoice,
  "Completed Tasks": faCheckCircle,
  "Pending RFIs": faQuestionCircle,
};

const StatisticCard = ({ title, value, theme }) => {
  return (
    <article
      className={`relative flex flex-col gap-4 rounded-lg border border-gray-100 bg-${theme === "light" ? "white" : "gray-800"} p-6 overflow-hidden group transition-all duration-200 hover:text-white`}
    >
      <div className={`absolute bottom-0 left-0 w-full h-0 bg-orange-400 transition-all duration-200 ease-out group-hover:h-full`}></div>

      <div className="relative z-10 flex items-center">
        <FontAwesomeIcon icon={iconMapping[title]} className={`text-3xl ${theme === "light" ? "text-gray-500" : "text-gray-300"} mr-2`} />
        <div>
          <strong className={`block text-md font-bold ${theme === "light" ? "text-gray-500" : "text-gray-300"} group-hover:text-white`}>
            {title}
          </strong>
          <p>
            <span className={`text-3xl font-medium ${theme === "light" ? "text-gray-900" : "text-gray-100"} group-hover:text-white`}>
              {value}
            </span>
          </p>
        </div>
      </div>
    </article>
  );
};

function Dashboard() {
  const [totalProjects,setTotalProjects] = useState(''); // Static value for total projects
  const [activeContracts,setActiveContracts] = useState(''); // Static value for active contracts
  const [completedTasks,setCompletedTasks] = useState(''); // Static value for completed tasks
  const [pendingRFIs,setPendingRFIs] = useState(''); // Static value for pending RFIs
  const [loading, setLoading] = useState(false);
  const user=JSON.parse(localStorage.getItem('user'))
const id=user._id
useEffect(() => {
  const fetchData = async (id) => {
   try{
    const res=await dashboardApi(id);
    //console.log(res.data.data)
     setTotalProjects(res.data.data.projects)
     setActiveContracts(res.data.data.pending_projects)
     setCompletedTasks(res.data.data.completed_projects)
     setPendingRFIs(res.data.data.rfiCount)
   }
   catch(err){
    console.log(err)
   }
  }
  fetchData(id);
},[id])
  const [chart, setChart] = useState({
    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      },
      theme: {
        mode: "light", // Set default theme to light
      },
    },
    series: [{
      name: "Monthly Completed Tasks",
      data: [10, 20, 40, 50, 60, 20, 30, 35, 45, 70, 25, 90], // Example static data
    }],
  });

  const { theme } = useTheme(); // Get the current theme

  useEffect(() => {
    // Update chart theme based on the selected theme
    setChart((prevChart) => ({
      ...prevChart,
      options: {
        ...prevChart.options,
        theme: {
          mode: theme === 'light' ? 'light' : 'dark', // Update the chart theme
        },
      },
    }));
  }, [theme]);

  // Simulating loading state (optional)
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Simulate loading time
  }, []);

  if (loading) {
   return (
         <div className="flex justify-center items-center h-screen">
           <Loader type="ThreeDots" color="#00BFFF" size="xl" />
   
         </div>
       );
   
  }

  return (
    <div className={`grid grid-cols-1 col-span-12 lg:col-span-10 gap-6 md:grid-cols-3 lg:grid-cols-4 p-4 `}>
      <StatisticCard title="Total Projects" value={totalProjects} theme={theme} />
      <StatisticCard title="Active Contracts" value={activeContracts} theme={theme} />
      <StatisticCard title="Completed Tasks" value={completedTasks} theme={theme} />
      <StatisticCard title="Pending RFIs" value={pendingRFIs} theme={theme} />
      
      <div className={`sm:flex justify-between rounded-lg col-span-full flex-1 shadow-md ${theme === 'light' ? 'bg-white' : 'bg-gray-800'}`}>
        <div className={`p-4 shadow-lg w-full rounded-md ${theme === 'light' ? 'bg-white' : 'bg-gray-800'}`}>
          <h3 className="text-lg font-bold mb-4">Monthly Task Progress</h3>
          <Chart options={chart.options} series={chart.series} type="line" />
        </div>

        <div className={`p-4 shadow-lg  rounded-md ${theme === 'light' ? 'bg-white' : 'bg-gray-800'}`}>
          <h3 className="text-lg font-bold mb-4">Task Distribution</h3>
          <Doughnut data={data} />
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
